/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Home_ResultInputs */

const en_gc_home_result = /** @type {(inputs: Gc_Home_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your total`)
};

const zh_gc_home_result = /** @type {(inputs: Gc_Home_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的合计`)
};

/**
* | output |
* | --- |
* | "Your total" |
*
* @param {Gc_Home_ResultInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_home_result = /** @type {((inputs?: Gc_Home_ResultInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Home_ResultInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_home_result(inputs)
	return zh_gc_home_result(inputs)
});
export { gc_home_result as "gc.home.result" }